import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const ScanIcon: FC<IconProps> = memo(
  ({ width, height, size, color }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(40);
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 40 40"
        fill="none"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.4717 4.28564H13.6995C14.0256 4.28564 14.2925 4.55249 14.2925 4.87864V6.65761C14.2925 6.98376 14.0256 7.2506 13.6995 7.2506H7.25067V13.7735C7.25067 14.0997 6.98383 14.3665 6.65768 14.3665H4.87871C4.55256 14.3665 4.28571 14.0997 4.28571 13.7735V5.47163C4.28571 4.81563 4.8157 4.28564 5.4717 4.28564ZM33.3423 25.6334H35.1213C35.4474 25.6334 35.7143 25.9002 35.7143 26.2263V34.5282C35.7143 35.1842 35.1843 35.7142 34.5283 35.7142H26.3005C25.9744 35.7142 25.7075 35.4474 25.7075 35.1212V33.3423C25.7075 33.0161 25.9744 32.7493 26.3005 32.7493H32.7493V26.2263C32.7493 25.9002 33.0162 25.6334 33.3423 25.6334ZM7.25067 32.7493H13.6995C14.0256 32.7493 14.2925 33.0161 14.2925 33.3423V35.1212C14.2925 35.4474 14.0256 35.7142 13.6995 35.7142H5.4717C4.8157 35.7142 4.28571 35.1842 4.28571 34.5282V26.2263C4.28571 25.9002 4.55256 25.6334 4.87871 25.6334H6.65768C6.98383 25.6334 7.25067 25.9002 7.25067 26.2263V32.7493ZM26.3005 4.28564H34.5283C35.1843 4.28564 35.7143 4.81563 35.7143 5.47163V13.7735C35.7143 14.0997 35.4474 14.3665 35.1213 14.3665H33.3423C33.0162 14.3665 32.7493 14.0997 32.7493 13.7735V7.2506H26.3005C25.9744 7.2506 25.7075 6.98376 25.7075 6.65761V4.87864C25.7075 4.55249 25.9744 4.28564 26.3005 4.28564ZM26.6429 21.4285C26.919 21.4285 27.1429 21.2046 27.1429 20.9285V19.0714C27.1429 18.7952 26.919 18.5714 26.6429 18.5714H13.3571C13.081 18.5714 12.8571 18.7952 12.8571 19.0714V20.9285C12.8571 21.2046 13.081 21.4285 13.3571 21.4285H26.6429Z"
          fill={color}
        />
      </Svg>
    );
  },
);
